module.exports = __webpack_public_path__ + "img/htmb.9f9ed181.jpg";